import * as React from "react";
import { Component, KeyboardEvent } from "react";
import { Keys } from "../../common/enums";

export interface OnKeyAction {
    key?: Keys;
    withCtrlKey?: boolean;
    withAltKey?: boolean;
    withShiftKey?: boolean;
    action?: F1<React.KeyboardEvent, any>;
    stopPropagation?: boolean;
    preventDefault?: boolean;
}

export interface WithKeyHandlersProps {
    className?: string;
    tabIndex?: number;
    divRef?: React.RefObject<HTMLDivElement>;
    actionsOnKeyDown?: OnKeyAction[];
    actionsOnKeyUp?: OnKeyAction[];
}

export class WithKeyHandlers extends Component<WithKeyHandlersProps> {
    constructor(props: WithKeyHandlersProps) {
        super(props);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    onKeyDown(e: KeyboardEvent<HTMLElement>) {
        return this.handleKeyEvent(e, this.props.actionsOnKeyDown);
    }

    onKeyUp(e: KeyboardEvent<HTMLElement>) {
        return this.handleKeyEvent(e, this.props.actionsOnKeyUp);
    }

    handleKeyEvent(e: KeyboardEvent<HTMLElement>, keyEventHandlers: OnKeyAction[]) {
        if (!keyEventHandlers) {
            return;
        }

        let keyHandler = keyEventHandlers.find(
            handler => handler && ((handler.key !== undefined && handler.key === e.key) || !handler.key)
        );

        if (
            keyHandler &&
            !!e.altKey >= !!keyHandler.withAltKey &&
            !!e.ctrlKey >= !!keyHandler.withCtrlKey &&
            !!e.shiftKey >= !!keyHandler.withShiftKey
        ) {
            if (keyHandler.stopPropagation) {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }
            if (keyHandler.preventDefault) {
                e.preventDefault();
            }
            keyHandler.action(e);
        }
    }

    render() {
        return (
            <div
                onKeyDown={this.onKeyDown}
                onKeyUp={this.onKeyUp}
                className={this.props.className}
                tabIndex={this.props.tabIndex}
                ref={this.props.divRef}
            >
                {this.props.children}
            </div>
        );
    }
}
